import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { IActivity } from 'typings/doenkids/doenkids';
import { IActivityHighlightState, ActivityHighlightStore } from './activity-highlight.store';

@Injectable({ providedIn: 'root' })
export class ActivityHighlightQuery extends QueryEntity<IActivityHighlightState, IActivity> {
  constructor(protected store: ActivityHighlightStore) {
    super(store);
  }
}
